import { render } from "./PcBuild.vue?vue&type=template&id=ca5d8932"
import script from "./PcBuild.vue?vue&type=script&lang=js"
export * from "./PcBuild.vue?vue&type=script&lang=js"

import "./PcBuild.vue?vue&type=style&index=0&id=ca5d8932&lang=css"

import exportComponent from "/home/kira/codemark/zonadigital/frond/deploy/zona-digital-ecommerce-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__